import { isBrowser } from "../../../utils/ssr";
import { getLocale } from "../../../utils/getLocale";

export function getLoggedInHomeURL() {
  if (!isBrowser()) {
    return undefined;
  }

  const locale = getLocale();

  const baseUrl = window.location.origin || process.env.GATSBY_WEBSITE_URL;

  switch (locale) {
    case "sv":
      return `${baseUrl}/se/home`;
    case "es":
      return `${baseUrl}/es/inicio`;
    default:
      return `${baseUrl}/home`;
  }
}
